import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const api = (path) => `${process.env.REACT_APP_API_URL}/api/v3/${path}`;
const config = () => ({ headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } });

/**
 * Task emails (docs/task-email-design.md). Admins: the switches, previews, tests and the log on
 * Task tools, Emails. Everyone: their own email settings.
 */
const TaskEmailService = {
    status: async () => (await axios.get(api('task-emails/points'), config())).data,
    update: async (body) => (await axios.put(api('task-emails/points'), body, config())).data,
    preview: async (point) => (await axios.get(api(`task-emails/points/${point}/preview`), config())).data,
    test: async (point) => (await axios.post(api('task-emails/test'), { point: point || null }, config())).data,
    digestPreview: async () => (await axios.get(api('task-notification-settings/digest-preview'), config())).data,
    runDigest: async () => (await axios.post(api('task-notification-settings/digest/run'), {}, config())).data,
    log: async (params) => (await axios.get(api('task-emails/log'), { ...config(), params })).data,
    logRow: async (id) => (await axios.get(api(`task-emails/log/${id}`), config())).data,
    mine: async () => (await axios.get(api('task-notification-prefs/me'), config())).data,
    myExample: async (point) => (await axios.get(api(`task-notification-prefs/me/${point}/example`), config())).data,
    updateMine: async (changes) => (await axios.put(api('task-notification-prefs/me'), changes, config())).data,
};

export default TaskEmailService;
